import React from 'react'
import { feature } from './classes'

export const Feature = ({ title, icon, size }) => {
    return (
        <li className={feature(size)}>
            {icon && <span>{icon}</span>}
            <span>{title}</span>
        </li>
    )
}

export const Features = ({ features, size, className = '' }) => {
    return (
        <ul className={`m-0 grid list-none gap-2 p-0 text-sm ${className}`}>
            {features.map((feature, index) => {
                const { title, icon } = feature
                return <Feature key={index} title={title} icon={icon} size={size} />
            })}
        </ul>
    )
}

export const Badge = ({ title, className = '' }) => {
    return (
        <span
            className={`rounded-sm border border-primary/50 py-1 px-2 text-xs font-normal leading-none opacity-50 ${className}`}
        >
            {title}
        </span>
    )
}

export const Title = ({ className = '', title, subtitle, badge, icon }) => {
    return (
        <div>
            {icon && <span className="inline-block opacity-30">{icon}</span>}
            <div>
                <div className="flex flex-wrap items-center">
                    <h3 className="m-0 mr-2 text-xl font-black">{title}</h3>
                    {badge && (
                        <span
                            className={`rounded-[3px] border border-primary/50 py-[4px] px-[4px] text-xs font-normal leading-none opacity-50`}
                        >
                            {badge}
                        </span>
                    )}
                </div>
                <p className="m-0 mt-1  text-sm font-medium">{subtitle}</p>
            </div>
        </div>
    )
}

export const Plan = ({ title, subtitle, badge, children, className = '', style = {}, icon }) => {
    return (
        <div style={style} className={`flex flex-col py-6 px-6 md:py-9 md:px-14 ${className}`}>
            <Title icon={icon} title={title} subtitle={subtitle} badge={badge} />
            {children}
        </div>
    )
}

export const Price = ({ children }) => {
    return <h5 className="m-0">{children}</h5>
}

export const Section = ({ title, children, className = '' }) => {
    return (
        <div className={className}>
            <h4 className="mb-3 mt-7 border-b border-dashed border-gray-accent-light pb-2 text-[15px] font-semibold opacity-50">
                {title}
            </h4>
            {children}
        </div>
    )
}
